import { downloadSingleDocument, downloadZipFolderDocuments } from '@/utils';
import { PayloadAction } from '@reduxjs/toolkit';
import { all, call, put } from 'redux-saga/effects';

import * as API from 'services';

import { groupDocumentDownloadByOwner } from './define-document-download.helper';
import { DefineDocumentDownloadActions } from './define-document-download.redux';
import {
	TPayloadDefineDownloadDocumentRequest,
	TPayloadGetDefineDocumentDownloadListRequest,
} from './define-document-download.type';

export function* getDefineDocumentDownloadList(
	action: PayloadAction<TPayloadGetDefineDocumentDownloadListRequest>
) {
	const { callback, ...restParams } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.TGetDocumentListByPageResponse> =
			yield API.getDocumentByPage(restParams);

		const allDocumentListByOwner = groupDocumentDownloadByOwner(
			res?.data?.content
		);

		yield put(
			DefineDocumentDownloadActions.getDefineDocumentDownloadListSuccess({
				defineDocumentDownloadList: allDocumentListByOwner,
			})
		);
		callback?.(res?.data?.content);
	} catch (error) {
		callback?.(error);
		yield put(
			DefineDocumentDownloadActions.getDefineDocumentDownloadListFailure()
		);
	}
}

export function* downloadDefineDocument(
	action: PayloadAction<TPayloadDefineDownloadDocumentRequest>
) {
	const { callback, path, pageType } = action.payload;
	try {
		const files: API.ApiResponseSuccess<Blob>[] = yield all(
			path.map((path) =>
				call(API.defineDocumentDownload, {
					...path,
				})
			)
		);

		yield downloadZipFolderDocuments({ files, pageType });
		callback?.();

		yield put(DefineDocumentDownloadActions.downloadDefineDocumentsSuccess());
	} catch (error) {
		callback?.({});
		yield put(DefineDocumentDownloadActions.downloadDefineDocumentsFailure());
	}
}

export function* downloadDefineDocumentByIds(
	action: PayloadAction<TPayloadDefineDownloadDocumentRequest>
) {
	const { callback, path, pageType } = action.payload;
	try {
		const files: API.ApiResponseSuccess<Blob>[] = yield all(
			path.map((path) =>
				call(API.defineDocumentDownloadById, {
					...path,
				})
			)
		);
		if (path.length > 1) {
			yield downloadZipFolderDocuments({ files, pageType });
		} else {
			yield downloadSingleDocument({ files });
		}
		callback?.();

		yield put(DefineDocumentDownloadActions.downloadDefineDocumentsSuccess());
	} catch (error) {
		callback?.({});
		yield put(DefineDocumentDownloadActions.downloadDefineDocumentsFailure());
	}
}
